import React from 'react'
import clsx from 'clsx'
import { Add, Minus } from 'iconsax-react'

import useStyles from './styles'

const CollapseButton = ({ open, onToggle, className = undefined }) => {
  const classes = useStyles()

  const Icon = open ? Add : Minus

  return (
    <div onClick={onToggle} className={clsx(classes.root, className)}>
      <Icon className='icon' />
    </div>
  )
}

export default CollapseButton
